import { jwtDecode } from '../../utils/jwt'
import { isEqual } from 'lodash'
import { createContext, useContext, useEffect, useState } from 'react'
import { COOKIE_NAME_JWT, COOKIE_NAME_USER_GROUP, USER_GROUP_NOT_LOGGED_IN, USER_GUEST } from '../../constants'
import { useCookiesByGroup } from '../../hooks/useCookiesByGroup'
import { useMemoCompare } from '../../hooks/useMemoCompare'

const UserDataContext = createContext()

const UserDataProvider = ({ authenticated, userGroup, children }) => {
	const [user, setUser] = useState({ isLoggedIn: authenticated, groupId: userGroup ?? USER_GROUP_NOT_LOGGED_IN })

	const [{ [COOKIE_NAME_USER_GROUP]: cookieUserGroupValue, [COOKIE_NAME_JWT]: cookieJwtValue }] = useCookiesByGroup([
		COOKIE_NAME_JWT,
		COOKIE_NAME_USER_GROUP,
	])

	const cookieUserGroup = cookieUserGroupValue && parseInt(cookieUserGroupValue)

	useEffect(() => {
		if (cookieJwtValue === undefined && cookieUserGroup === undefined) {
			// when logged out cookies are undefined and we set guest user
			setUser(USER_GUEST) // use same reference across renders
		} else if (cookieUserGroup !== undefined && cookieUserGroup !== user.groupId) {
			setUser({
				isLoggedIn:
					!!cookieJwtValue &&
					jwtDecode(cookieJwtValue)?.aud?.includes('self') &&
					cookieUserGroup !== USER_GROUP_NOT_LOGGED_IN,
				groupId: cookieUserGroup,
			})
		}
	}, [cookieUserGroup, cookieJwtValue, user])

	const value = useMemoCompare(user, isEqual)

	return <UserDataContext.Provider value={value}>{children}</UserDataContext.Provider>
}

export default UserDataProvider
export const useUserData = () => useContext(UserDataContext)
